export default __webpack_public_path__ + "static/media/calculator.6f6b6b2a.svg";